const updateUserAccess = {
  toastr: 'Usuário atualizado',
  toastr1: ' foi atualizado com sucesso',
  toastrError: 'Nome já cadastrado',
  toastrError1: 'Insira outro nome'
};

export default updateUserAccess;
